import React, { useState, useEffect, useRef } from "react";
import { FaStar } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import "../styles/starStyles.css"; // Import the CSS file

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  starCount?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  maxRating = 100,
  starCount = 5,
}) => {
  const [isHovering, setIsHovering] = useState(false); // Overall hover state
  const [tooltipOpen, setTooltipOpen] = useState(false); // Tooltip open state
  const starRef = useRef<HTMLDivElement | null>(null); // Reference to the star container
  const starRating = (rating / maxRating) * starCount;

  const handleMouseEnter = () => {
    setIsHovering(true);
    setTooltipOpen(true); // Show the tooltip when hovering
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setTooltipOpen(false); // Hide the tooltip when leaving the stars
  };

  return (
    <div
      style={{
        // height: "100vh",
        display: "flex",
        position: "relative",
      }}
      className="star-rating"
      onMouseEnter={handleMouseEnter} // Show tooltip when hovering over stars
      onMouseLeave={handleMouseLeave} // Hide tooltip when mouse leaves stars
      ref={starRef}
    >
      {/* Loop through and render stars */}
      {[...Array(starCount)].map((_, index) => {
        const fillPercentage = Math.min(
          100,
          Math.max(0, (starRating - index) * 100),
        );

        return (
          <div key={index} className="star-container">
            {/* Star with clip-path to control how much is filled */}
            <div className="star-wrapper">
              <FaStar
                className="star filled-star"
                style={{
                  clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`, // Fills the star based on rating
                }}
              />
              <FaStar className="star empty-star" />
            </div>
          </div>
        );
      })}

      {/* Tooltip under the 3rd star, always open when hovering */}
      {isHovering && (
        <Tooltip
          title={`${starRating.toFixed(1)}`} // Format to one decimal place
          placement="bottom"
          open={tooltipOpen} // Keep the tooltip open as long as hovering
          arrow={false} // No arrow in the tooltip
        >
          <div
            style={{
              position: "absolute",
              top: "100%", // Position tooltip just below the stars
              left: `69px`, // Adjust the position to center it
              transform: "translateX(-50%)", // Center the tooltip exactly under the 3rd star
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default StarRating;
